import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './i18n/config';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import { useSelector } from 'react-redux';

// Layout Components
import Layout from './components/layout/Layout';
import NotFound from './components/NotFound';

// Auth Pages
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import Profile from './pages/auth/Profile';

// Dashboard Pages
import Dashboard from './pages/dashboard/Dashboard';

// Office Pages
import Offices from './pages/offices/Offices';

const PrivateRouteComponent = ({ children }) => {
  const { token } = useSelector(state => state.auth);

  if (!token) {
    console.log('No token found');
    return <Navigate to="/login" />;
  }

  return children;
};

function App() {
  return (
    <>
      <Routes>
        {/* Auth Routes */}
        <Route path="/login" element={<Login/>} />
        <Route path="/forgot-password" element={<ForgotPassword/>} />
        
        {/* Protected Routes */}
        <Route path="/" element={
            <PrivateRouteComponent>
              <Layout />
            </PrivateRouteComponent>
          }>
            <Route path="" element={<Navigate to="/dashboard" />} />        
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="offices" element={<Offices />} />
            <Route path="profile" element={<Profile />} />
            <Route path="reset-password" element={<ResetPassword/>} />

            {/* Approval Route */}
            <Route path="dashboard/:rqst_sn/approve" element={<Dashboard />} />

        </Route>

        {/* Default Route */}
        <Route path="/" element={<Navigate to="/dashboard" />} />

        {/* 404 Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>

      <ToastContainer
        position="top-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;